import { useState } from "react";
import { register, setup2fa, type RegisterResponse } from "../api/auth";
import Setup2FAPage from "./Setup2FAPage";

export default function BootstrapPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [reg, setReg] = useState<RegisterResponse | null>(null);
  const [blocked, setBlocked] = useState(false);

  // The ticket died before the admin finished enrolling. The account exists
  // and its password is set, so the way out is the login page: signing in
  // takes the never-enrolled path, which issues a fresh ticket.
  if (blocked) {
    return (
      <div className="auth-screen">
        <div className="auth-card">
          <h1>Two-factor setup timed out</h1>
          <p>
            Your admin account was created. Sign in with the password you just
            chose to finish setting up your authenticator app.
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Go to sign in
          </button>
        </div>
      </div>
    );
  }

  if (reg) {
    return (
      <Setup2FAPage
        provisioningUri={reg.totpProvisioningUri}
        secret={reg.totpSecret}
        verify={async (code) => {
          const r = await setup2fa(reg.enrollToken, code);
          // Throwing is what stops Setup2FAPage calling onDone on a failure.
          if (r.kind !== "ok") {
            setBlocked(true);
            throw new Error(`enrolment blocked: ${r.kind}`);
          }
        }}
      />
    );
  }

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await register(email, password);
      setReg(r);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <h1>Create the first admin</h1>
        <p>No accounts exist yet. Create the first admin account below.</p>
        <form onSubmit={submit}>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              autoComplete="email"
            />
          </label>
          <label>
            Password (min. 8 characters)
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </label>
          {error && <p className="auth-error">{error}</p>}
          <button type="submit" disabled={busy || !email || password.length < 8}>
            {busy ? "Creating…" : "Create admin account"}
          </button>
        </form>
      </div>
    </div>
  );
}
